import { IS_STRAPI_DEV, DEV_HOST } from '@monoimin/constants';

import { GET } from '../api';

import type { Locales } from '@monoimin/sb-types';

export async function getStrapiEstateBySlug({
  slug,
  locale = 'en',
  isDraft = false,
  countrySlug,
}: {
  slug: string;
  locale?: Locales;
  isDraft?: boolean;
  countrySlug?: string;
}) {
  const countryFilter = countrySlug
    ? {
        country: {
          slug: countrySlug,
        },
      }
    : {};
  const { data, error } = await GET(`/estates`, {
    params: {
      query: {
        populate: '*',
        filters: {
          slug,
          ...countryFilter,
        },
        locale,
        publicationState: isDraft ? 'preview' : 'live',
      },
    },
  });

  if (error) {
    return null;
  }

  const estateBySlug = data?.data?.[0];

  if (IS_STRAPI_DEV && estateBySlug) {
    if (estateBySlug.main_image) {
      estateBySlug.main_image.url = DEV_HOST + estateBySlug.main_image.url;
    }
    if (estateBySlug.images?.length) {
      estateBySlug.images = estateBySlug.images.map((i) => ({
        ...i,
        url: DEV_HOST + i.url,
      }));
    }
  }

  return estateBySlug;
}

export default getStrapiEstateBySlug;
